---
title: "Interne vs. externe Standorte"
slug: internal-vs-external-locations
description: "Interne Standorte können Pakete scannen; externe Standorte sind Empfänger außerhalb Ihres Unternehmens."
keywords:
  - Standort
  - intern
  - extern
  - Empfänger
  - Scan
  - Paketstatus
  - Ausstehend
---

## Was ist ein interner Standort?

Ein interner Standort ist ein Ort, der zu Ihrem Unternehmen gehört und aktiv am Kreislauf teilnimmt. Mitarbeiter mit der Rolle Scanner, Manager oder Admin können dort Pakete senden und empfangen.

Typische Beispiele: Lager, Produktionshalle, Filiale oder ein Bürostandort.

Interne Standorte erscheinen in der Dropdown-Liste, wenn Sie einen Scan starten. Sie müssen mindestens einen internen Standort eingerichtet haben, bevor Sie das erste Paket senden oder empfangen können.

## Was ist ein externer Standort?

Ein externer Standort (auch: externer Empfänger) ist eine Adresse außerhalb Ihres Unternehmens — zum Beispiel ein Kunde, ein Partner oder ein Dienstleister.

Externe Standorte **können keine Pakete scannen**. Sie sind reine Empfängeradressen. Sobald ein Paket an einen externen Standort gesendet wird, verbleibt es im Status **"Unterwegs"**, bis es bei einem internen Standort zurückgescannt wird.

## Paketstatus: Ausstehend bis zur Rückkehr

Wenn Sie ein Paket an einen externen Standort senden, wechselt der Status auf **"Unterwegs"**. Das Paket gilt als ausgeliehen — nicht als verloren oder abgerechnet.

Der Status ändert sich erst zurück auf **"Verfügbar"**, wenn das Paket an einem Ihrer internen Standorte empfangen (zurückgescannt) wird. Erst dann ist der Kreislauf geschlossen.

Solange ein Paket bei einem externen Empfänger liegt, wird automatisch der Rückgabeprozess überwacht: Hat der Empfänger das Paket zu lange, erhalten Sie eine Erinnerung und später eine Rechnung (siehe [Paket-Lebenszyklus](/app/help?article=package-lifecycle)).

## Praktischer Unterschied auf einen Blick

| | Interner Standort | Externer Standort |
|---|---|---|
| Kann scannen | Ja | Nein |
| Kann Pakete empfangen (Scan) | Ja | Nein |
| Erscheint als Absender-/Empfängerauswahl | Ja | Nur als Empfänger |
| Pakete kehren von hier zurück | Ja | Nein — Paket kommt erst bei intern-Scan zurück |

## Verwandte Artikel

- [Pakete senden](/app/help?article=sending-a-package)
- [Pakete empfangen](/app/help?article=scanning-a-package)
- [Paket-Lebenszyklus](/app/help?article=package-lifecycle)
- [Ersteinrichtung](/app/help?article=initial-setup)
